import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import {
    createLoadDataAction,
    getFetchingCount,
    getFetchingState,
    getRecordsIds,
} from "@multiweb/reactCore/datasource";
import { createGetRootNodesChildrenCount } from "@multiweb/reactCore/workflow";
import { IAppState } from "@multiweb/types/react";
import { GridParticipantsComponent, GridParticipantsComponentProps } from "../GridParticipantsComponent";

export type GridParticipantsProps = {
    /** Unikátní klíč pro DataSource. */
    readonly dataSourceKey: string;
};

type StateProps = Pick<GridParticipantsComponentProps, "recordsIds" | "fetchingState" | "fetchingCount" | "rootNodesChildrenCount">;

const createMapStateToProps: (state: IAppState, props: GridParticipantsProps) => MapStateToProps<StateProps, GridParticipantsProps, IAppState> = () => {
    const getRootNodesChildrenCount = createGetRootNodesChildrenCount();

    return (state, { dataSourceKey }) => ({
        recordsIds: getRecordsIds(state, dataSourceKey),
        fetchingState: getFetchingState(state, dataSourceKey),
        fetchingCount: getFetchingCount(state, dataSourceKey),
        rootNodesChildrenCount: getRootNodesChildrenCount(state, dataSourceKey),
    });
};

type DispatchProps = Pick<GridParticipantsComponentProps, "loadData">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, GridParticipantsProps> = (
    dispatch,
    { dataSourceKey },
) => ({
    loadData: () => dispatch(createLoadDataAction(dataSourceKey)),
});

export const GridParticipants = connect(createMapStateToProps, mapDispatchToProps,
)(GridParticipantsComponent);
